import { PACKAGES, findPackageBySlug } from "@/data/packages";

export type ProjectType = "aiProduct" | "automation" | "improve" | "notSure";
export type Scope = "idea" | "specs" | "running";
export type Timeline = "asap" | "quarter" | "exploring";
export type Budget = "under10k" | "10kTo25k" | "over25k" | "guidance";

export interface EstimatorAnswers {
  projectType: ProjectType;
  scope: Scope;
  timeline: Timeline;
  budget: Budget;
}

export interface EstimateResult {
  packageSlug: string;
  confidence: "fit" | "closest";
}

export function estimateRecommendation(
  answers: EstimatorAnswers
): EstimateResult {
  const { projectType, budget } = answers;

  if (projectType === "automation") {
    return { packageSlug: "automation-audit", confidence: "fit" };
  }

  if (projectType === "improve") {
    return { packageSlug: "conversion-teardown", confidence: "fit" };
  }

  if (projectType === "aiProduct") {
    return { packageSlug: "ai-mvp", confidence: "fit" };
  }

  // notSure — use budget as a tiebreaker
  if (budget === "under10k") {
    return { packageSlug: "automation-audit", confidence: "closest" };
  }

  // Default: featured package (ai-mvp)
  const featured = PACKAGES.find((p) => p.featured);
  const slug = featured?.slug ?? "ai-mvp";
  return { packageSlug: slug, confidence: "closest" };
}

export function isValidResult(result: EstimateResult): boolean {
  return findPackageBySlug(result.packageSlug) !== undefined;
}
